module.exports = __webpack_public_path__ + "static/media/input_r.8cee7839.png";